export type F2FCancellationPayload = {
  success?: boolean;
  partial_success?: boolean;
  cancellation_persisted?: boolean;
  candidate_notified?: boolean;
  notification_status?: string;
  notification_outcome_recorded?: boolean;
  error?: string;
};

export type F2FCancellationUiOutcome = 'notified' | 'cancelled_notification_failed' | 'failed';

export function resolveF2FCancellationUiOutcome(
  payload: F2FCancellationPayload | null | undefined,
): F2FCancellationUiOutcome {
  if (payload?.success === true && payload.candidate_notified === true) return 'notified';
  if (payload?.cancellation_persisted === true || payload?.partial_success === true) {
    return payload.candidate_notified === true && payload.notification_status === 'sent'
      ? 'notified'
      : 'cancelled_notification_failed';
  }
  return 'failed';
}

export function canEditF2FInvitation(responseStatus: string | null | undefined) {
  return !responseStatus;
}

export function canRescheduleF2FInvitation(responseStatus: string | null | undefined) {
  return responseStatus === 'declined_by_candidate' || responseStatus === 'cancelled_by_employer';
}

export function shouldHydrateF2FEditDraft(isNewDialogTarget: boolean, isEditing: boolean) {
  return isNewDialogTarget || !isEditing;
}

export async function readEdgeFunctionErrorPayload(error: unknown): Promise<F2FCancellationPayload | null> {
  if (!error || typeof error !== 'object' || !('context' in error)) return null;
  const context = (error as { context?: { json?: () => Promise<unknown> } }).context;
  if (!context || typeof context.json !== 'function') return null;
  try {
    return await context.json() as F2FCancellationPayload;
  } catch {
    return null;
  }
}
